import axios from 'axios';
import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import { useParams } from "react-router-dom";
import Loading from "./Loading";
import NotFound from "./NotFound";
import toast from "react-hot-toast";
import '@emran-alhaddad/saudi-riyal-font/index.css';

// Ensure consistent handling of cart data
function consolidateObjects(objects) {
  const consolidated = {};

  objects.forEach((obj) => {
    if (consolidated[obj.service_id]) {
      consolidated[obj.service_id].quantity += obj.quantity;
    } else {
      consolidated[obj.service_id] = { ...obj };
    }
  });

  return Object.values(consolidated);
}

const ServiceDetails = () => {
  const { t, i18n } = useTranslation();
  const activeLanguage = i18n.language;
  const { id: serviceId } = useParams();
  const [serviceData, setServiceData] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(undefined);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [quantity, setQuantity] = useState(1);

  useEffect(() => {
    setLoading(true);
    const fetchServices = async () => {
      try {
        const response = await axios.get(`https://demo-two.keytime.sa/api/services/${serviceId}`, {
          headers: {
            "Content-Type": "application/json",
          },
        });
        setServiceData(response.data);
      } catch (error) {
        setError("Service not found");
        console.error("Error fetching services:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchServices();
  }, [serviceId]);

  useEffect(() => {
    if (serviceData) {
      const existCart = JSON.parse(localStorage.getItem('cartItems')) || [];
      const isItemInCart = existCart.some(item => item.service_id === serviceData.service_id);
      setIsButtonDisabled(isItemInCart);
    }
  }, [serviceData]);

  const addToCart = () => {
    if (isButtonDisabled) return;

    const existCart = JSON.parse(localStorage.getItem('cartItems')) || [];
    const newItem = { ...serviceData, quantity };
    const updatedCart = [...existCart, newItem];

    // Consolidate cart items by service_id
    const consolidatedCart = consolidateObjects(updatedCart);

    // Update localStorage
    localStorage.setItem('cartItems', JSON.stringify(consolidatedCart));

    // Dispatch a custom event to notify other components
    const cartUpdateEvent = new CustomEvent('cartUpdated', {
      detail: { cart: consolidatedCart }
    });
    window.dispatchEvent(cartUpdateEvent);

    setIsButtonDisabled(true);
    setQuantity(1);

    toast.success(activeLanguage === "ar" ? "تمت الإضافة إلى السلة بنجاح!" : "Added to cart successfully!", {
      position: "top-right",
      duration: 3000,
    });
  };

  if (error) return <NotFound titleText={'Product not found !!'} />;
  if (loading || !serviceData) return <Loading />;

  const { currency, description, service_id, name, price, thumbnail, description_en, name_en } = serviceData || {};

  return (
    <>
      <Helmet>
        <title>الخدمات</title>
      </Helmet>
      <div className="py-10">
        <div className="w-[80%] flex m-auto gap-12 flex-col-reverse md:flex-row">
          <div className="w-[100%] md:w-[50%] text-right flex flex-col">
            <p className="text-[28px] font-bold text-[#4a4a4a]">{activeLanguage === 'ar' ? name : name_en}</p>
            <p className="mt-[35px] mb-[17px] text-[#1f436a] text-[20px] font-semibold icon-saudi_riyal">{price} </p>
            <p className="ml-auto max-w-[420px] text-[14px] text-[#818286]">{activeLanguage === 'ar' ? description : description_en}</p>
            <button
              onClick={addToCart}
              disabled={isButtonDisabled}
              className={`ml-auto w-full max-w-[580px] mt-[50px] rounded-[4px] py-3 text-white ${isButtonDisabled ? 'bg-gray-400 cursor-not-allowed' : 'bg-[#1f436a] hover:bg-[#1c3c60] active:bg-[#1c3c60]'}`}
              type="button"
            >
              {isButtonDisabled
                ? (activeLanguage === "ar" ? "العنصر موجود بالفعل في السلة" : "Item already in the cart.")
                : (activeLanguage === "ar" ? "إضافة إلى السلة" : "Add to cart")}
            </button>
          </div>
          <div className="w-[100%] md:w-[50%]">
            <img className="rounded-[6px]" src={`/serviceImages/${thumbnail}`} alt="IMG" />
          </div>
        </div>
      </div>
    </>
  );
};

export default ServiceDetails;
